import React, { useState } from 'react';
import GameTable from './GameTable';
import DeleteConfirmModal from './DeleteConfirmModal';

const GamesTab = ({ games, loading, onRefresh, onEdit, onImageUpload, onSelect }) => {
    const [deleteConfirm, setDeleteConfirm] = useState(null);
    const [deleteType, setDeleteType] = useState('soft');

    if (loading) return <div className="admin-loading-state">Loading games...</div>;

    return (
        <div className="admin-games-tab">
            <div className="admin-tab-header">
                <h2 className="admin-tab-title">Games Management</h2>
                <button className="admin-btn-add" onClick={() => onEdit(null)}>
                    + Add New Game
                </button>
            </div>

            {games.length === 0 ? (
                <div className="admin-empty-state">
                    <p>No games found. Click "Add New Game" to create one.</p>
                </div>
            ) : (
                <GameTable
                    games={games}
                    onEdit={onEdit}
                    onImageUpload={onImageUpload}
                    onDelete={setDeleteConfirm}
                    onRowClick={onSelect}
                />
            )}

            {deleteConfirm && (
                <DeleteConfirmModal
                    deleteConfirm={deleteConfirm}
                    deleteType={deleteType}
                    setDeleteType={setDeleteType}
                    onClose={() => setDeleteConfirm(null)}
                    onRefresh={onRefresh}
                />
            )}
        </div>
    );
};

export default GamesTab;